import React from 'react';
import _ from 'lodash';
import FeedContainerSmall from '../NewsFeed/FeedContainerSmall';
import ArticleLink from '../ArticleLink';

export default class LongformFeed extends React.PureComponent {

  render() {
    const { contentContainers } = this.props;

    const groups = _.groupBy(contentContainers, 'tags.programType.name');

    return (
      <div className="broadcastarea-feed">
        {
          _.map(groups, (group, groupName) => {
            return (
              <div key={groupName} className="highlight-box">
                { groupName !== 'undefined' && <div className="section">
                  <ArticleLink contentContainer={group[0]} className="text-colored-link">
                    <h3>{groupName}</h3>
                  </ArticleLink>
                </div> }
                <div className="section">
                  {
                    _.map(group, contentContainer =>
                        <FeedContainerSmall key={contentContainer.id} contentContainer={contentContainer} />
                    )
                  }
                </div>
              </div>
            );
          })
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Sidebar/LongformFeed.jsx